import { differenceInYears, format, isBefore } from 'date-fns'
import { TFunction } from 'i18next'

import { FeatureOptions } from '@wwt/entities/search-response'
import { TooltipIconDetails } from '@wwt/ui/components/Tooltips'

import { getTooltipTypes } from '../types/TooltipTypes'

export const getTooltipIconsDetails = (
	isCheckInFeature: boolean,
	selectedOption: FeatureOptions,
	t: TFunction<'tooltips', undefined>
): TooltipIconDetails[] => {
	const now = new Date()
	const expiredAt = selectedOption.expiredAt
		? new Date(selectedOption.expiredAt)
		: null
	const formattedExpiredAt = expiredAt ? format(expiredAt, 'MMMM d') : ''
	const isExpired = expiredAt && isBefore(expiredAt, now)
	const isExpiring = expiredAt && differenceInYears(expiredAt, now) <= 1

	const TooltipTypes = getTooltipTypes(t, formattedExpiredAt)

	return [
		selectedOption.isWarning && TooltipTypes.warning,
		isExpired && TooltipTypes.expired,
		isCheckInFeature && TooltipTypes.dollar,
		isExpiring && !isExpired && TooltipTypes.expiring,
		selectedOption.isFromReview && TooltipTypes.smile,
		selectedOption.isCustom && TooltipTypes.custom
	].filter(Boolean) as TooltipIconDetails[]
}
